import React from 'react';
import FieldWrapper from '../FieldWrapper';
import Checkbox from '../Checkbox';
import Dropdown from '../Dropdown';
import {Field} from '@nexios/frontend-forms';
import styled, {withTheme} from 'styled-components';


const SubtleText = styled.div`
  color: ${props => props.theme?.telemarketingText?.color || props.theme?.inputCheckbox?.label?.color || 'inherit'};
  font-size: ${props => props.theme?.telemarketingText?.fontSize || props.theme?.inputCheckbox?.label?.fontSize || 'inherit'};
  line-height: ${props => props.theme?.telemarketingText?.lineHeight || 'inherit'};
`;

const Container = styled.div`
  margin-top: ${props => props.theme?.telemarketingContainer?.marginTop || 'inherit'};
`;

const SideBySide = styled.div`
  display: grid;
  grid-template-columns: ${props => props.theme.optInDisplay?.sideBySideColumns || '94px 1fr'};
  align-items: top;
  gap: ${props => props.theme.optInDisplay?.sideBySideGap || '8px'};
`;

const SideBySideLabel = styled.div`
  color: ${props => props.theme.optInDisplay?.sideBySideLabel?.color};
  font-size: ${props => props.theme.optInDisplay?.sideBySideLabel?.fontSize};
  font-weight: ${props => props.theme.optInDisplay?.sideBySideLabel?.fontWeight};
  line-height: ${props => props.theme.optInDisplay?.sideBySideLabel?.lineHeight};
`;

function Telemarketing(
  {
    telemarketingOptIn,
    telemarketingInfoText,
    telemarketingCheckBoxText,
    noMargin,
    theme
  }) {
  const infoTxt = telemarketingOptIn === 'text' || telemarketingOptIn === 'button' ?
    <SubtleText>{telemarketingInfoText}</SubtleText> : null;

  const isDropdown = telemarketingOptIn === 'dropdown';
  const isSideBySide = isDropdown && theme?.optInDisplay?.layout === 'sideBySide';

  let inputField;
  if (isSideBySide) {
    inputField = <SideBySide>
      <Field
        name='allowTelemarketing'
        list='optInChoices'
        placeholder='Kies'
        component={FieldWrapper}
        inputComponent={Dropdown}
        hideLabel
        noMargin={noMargin}
      />
      <Field
        name='allowTelemarketing'
        component={() => <SideBySideLabel>{telemarketingCheckBoxText}</SideBySideLabel>}
        hideLabel
      />
    </SideBySide>;
  } else if (isDropdown) {
    inputField = <Field
      label={telemarketingCheckBoxText}
      name='allowTelemarketing'
      list='optInChoices'
      placeholder='Maak een keuze'
      component={FieldWrapper}
      inputComponent={Dropdown}
      style={noMargin ? {marginTop: '5px'} : null}
      noMargin={noMargin}
    />;
  } else {
    inputField = <Field
      label={telemarketingCheckBoxText}
      name='allowTelemarketing'
      component={FieldWrapper}
      inputComponent={Checkbox}
      hideLabel
      subtle
      style={noMargin ? {marginTop: '5px'} : null}
      noMargin={noMargin}
    />;
  }
  const text = <Field
    name='telemarketingInfoText'
    component={() => infoTxt}
  />;

  if (noMargin) {
    return <>
      {inputField}
      {text}
    </>;
  }
  return <Container className='marginBottom'>
    {inputField}
    {text}
  </Container>;
}

export default withTheme(Telemarketing);
